export default {
  setActive(state, product) {
    state.active = product;
  },

  clearActive(state) {
    state.active = null;
  },
};
